module.exports = __webpack_public_path__ + "static/media/safari-ios.080ae283.svg";